/**
 * @fileoverview added by tsickle
 * Generated from: serializers/worker-mood-sample.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { dateTimeField, modelSerializer } from '../util/serializers';
import { interventionSampleCampaign, moodSampleCampaign, workerInterventionSample, workerMoodSample } from '../models/worker-mood-sample';
/** @type {?} */
export var moodSampleCampaignSerializer = (/** @type {?} */ ((/** @type {?} */ (modelSerializer.extend({
    model: moodSampleCampaign
})))));
/** @type {?} */
export var workerMoodSampleSerializer = (/** @type {?} */ ((/** @type {?} */ (modelSerializer.extend({
    model: workerMoodSample,
    fields: {
        sampled_at: dateTimeField.create()
    }
})))));
/** @type {?} */
export var interventionSampleCampaignSerializer = (/** @type {?} */ ((/** @type {?} */ (modelSerializer.extend({
    model: interventionSampleCampaign
})))));
/** @type {?} */
export var workerInterventionSampleSerializer = (/** @type {?} */ ((/** @type {?} */ (modelSerializer.extend({
    model: workerInterventionSample,
    fields: {
        sampled_at: dateTimeField.create()
    }
})))));
